import { render, staticRenderFns } from "./ReceivingAddress.vue?vue&type=template&id=4c49aa16&scoped=true&"
import script from "./ReceivingAddress.vue?vue&type=script&lang=js&"
export * from "./ReceivingAddress.vue?vue&type=script&lang=js&"
import style0 from "./ReceivingAddress.vue?vue&type=style&index=0&id=4c49aa16&lang=scss&scoped=true&"
import style1 from "./ReceivingAddress.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c49aa16",
  null
  
)

export default component.exports